import { Modal } from "bootstrap";

export function showWarning(message, callBack) {
  //showModal("Warning", message, "text-warning", " btn btn-warning");
  showModal("Warning", message, "text-danger", " btn btn-danger", callBack);
}
export function showSucess(message, callBack) {
  showModal("Success", message, "text-success", " btn btn-success", callBack);
}

export function showError(message, callBack) {
  showModal("Error", message, "text-danger", " btn btn-danger", callBack);
}

function showModal(title, message, modalClass, btn, callBack) {
  var div = document.createElement("div");
  div.classList.add("class", "modal");
  div.classList.add("class", modalClass);

  div.setAttribute("tabindex", "-1");
  div.style.zIndex = 99999;
  div.setAttribute("id", "modalerror");
  div.innerHTML = ` <div class="modal-dialog">
    <div class="modal-content alert-shadow">
      <div class="modal-header">
        <h5 class="modal-title">${title}</h5>
      </div>
      <div class="modal-body">
        <p>${message}</p>
      </div>
      <div class="modal-footer" id="modal-footer">
       
      </div>
    </div>
  </div>`;

  let button = document.createElement("button");
  button.setAttribute("class", btn);
  button.innerText = "Ok";

  div.children[0].children[0].children[2].appendChild(button);
  if (callBack) {
    let buttonCancel = document.createElement("button");
    buttonCancel.setAttribute("class", "btn");
    buttonCancel.innerText = "Cancel";
    div.children[0].children[0].children[2].appendChild(buttonCancel);
    buttonCancel.onclick = () => {
      myModal.hide();
      let modalToremove = document.getElementById("modalerror");
      if (modelElemt)
        document.getElementById("root").removeChild(modalToremove);
      myModal.dispose();
    };
  }
  document.getElementById("root").appendChild(div);
  let modelElemt = document.getElementById("modalerror");
  let myModal = new Modal(modelElemt, {
    keyboard: false,
    backdrop: false
  });
  button.onclick = () => {
    if (callBack) callBack();
    myModal.hide();
    let modalToremove = document.getElementById("modalerror");
    if (modelElemt) document.getElementById("root").removeChild(modalToremove);
    myModal.dispose();
  };
  myModal.show();
}
